import { render, staticRenderFns } from "./terceiros-icon.vue?vue&type=template&id=06e8ff3e&"
import script from "./terceiros-icon.vue?vue&type=script&lang=js&"
export * from "./terceiros-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports